module.exports = __webpack_public_path__ + "media/audio94.17c78952.mp3";